(function() {
  const filters = document.querySelector('.filters');
  const filtersBar = document.querySelector('.filters__bar');
  const navigation = document.querySelector('.navigation');

  if (!filters || !filtersBar || !navigation) return;

  // Updates filters min-height to match filters__bar
  function setFiltersHeight() {
    filters.style.setProperty('--filters-bar-height', filtersBar.offsetHeight + 'px');
  }

  // Handles the sticky behaviour
  function stickFiltersBar() {
    // Use offsetHeight for nav height, but getBoundingClientRect for precise positioning
    const navTop = navigation.offsetHeight + navigation.getBoundingClientRect().top;
    const filtersTop = filters.getBoundingClientRect().top;

    if (filtersTop <= navTop) {
      if (!filtersBar.classList.contains('is-sticky')) {
        filtersBar.classList.add('is-sticky');
        filtersBar.style.position = 'fixed';
        filtersBar.style.top = navTop + 'px';
        filtersBar.style.left = filters.getBoundingClientRect().left + 'px';
        filtersBar.style.width = filters.offsetWidth + 'px';
        filtersBar.style.zIndex = 1;
      }
    } else {
      filtersBar.classList.remove('is-sticky');
      filtersBar.style.position = '';
      filtersBar.style.top = '';
      filtersBar.style.left = '';
      filtersBar.style.width = '';
      filtersBar.style.zIndex = '';
    }
    setFiltersHeight(); // ensure min-height is always correct
  }

  window.addEventListener('resize', setFiltersHeight);
  window.addEventListener('resize', stickFiltersBar);
  window.addEventListener('scroll', stickFiltersBar);
  window.addEventListener('DOMContentLoaded', setFiltersHeight);

  // Initial run
  setFiltersHeight();
  stickFiltersBar();
})();